<template>
    <div class="main-container">
        <el-form ref="searchForm" :model="searchForm" inline label-width="100" class="search-form"
                @keydown.enter.native.prevent="handleSearch" size="small">
            <el-form-item label="模板名称" prop="title">
                <el-input type="text" v-model="searchForm.title" clearable placeholder="请输入模板名称" style="width: 260px"></el-input>
            </el-form-item>

            <el-form-item label="公众号APPID" prop="appId">
                <el-input type="text" v-model="searchForm.appId" clearable placeholder="请输入公众号APPID" style="width: 260px"></el-input>
            </el-form-item>

            <el-form-item label="模板类型" prop="templateType">
                <el-select v-model="searchForm.templateType" clearable placeholder="请选择" style="width: 260px">
                    <el-option v-for="(item,index) in templateTypeList" :key="index" :label="item.desc" :value="item.name"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="模板Id" prop="templateId">
                <el-input type="text" v-model="searchForm.templateId" clearable placeholder="请输入模板Id" style="width: 260px"></el-input>
            </el-form-item>

            <el-form-item class="br">
                <el-button @click="handleSearch" type="primary" icon="ios-search" size="small">搜索</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table border :data="tableData" :loading="isLoading" size="small" style="width:100%;margin-top:10px;">
            <el-table-column prop="createTime" label="创建时间" align="center" width="160"></el-table-column>
            <el-table-column prop="appId" label="公众号ID" align="center" width="160"></el-table-column>
            <el-table-column prop="templateTypeDesc" label="模板类型" width="160"></el-table-column>
            <el-table-column prop="title" label="模板名称" width="160"></el-table-column>
            <!-- <el-table-column prop="realTime" label="类型" width="120">
                <template slot-scope="{row}">
                    <span>{{ row.realTime == 1 ?  "实时" : (row.realTime == 2 ? '定时': '')}}</span>
                </template>
            </el-table-column> -->
            <el-table-column prop="enable" label="状态" width="100" align="center">
                <template slot-scope="{row}">
                    <el-tag type="success" v-if="row.enable == 1">开启</el-tag>
                    <el-tag type="warning" v-else>关闭</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="templateId" label="模板ID" width="350"></el-table-column>
            <el-table-column prop="content" label="模板内容" width="350">
                <template slot-scope="{row}">
                    <div style="white-space:pre-wrap;">{{ row.content }}</div>
                </template>
            </el-table-column>
            
            <el-table-column label="操作" align="center" fixed="right" width="200">
                <template slot-scope="{row}">
                    <el-button type="primary" size="small" @click="handledEdit(row)">编辑</el-button>
                    <el-button type="danger" size="small" @click="handleDel(row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.current" style="text-align:right;margin-top:10px;"
        :page-sizes="[10, 20, 50]" :page-size="searchForm.size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>

        <!-- 新增/编辑 -->
        <el-dialog :title="title" :visible.sync="isShow" width="600px" :mask-closable="false">
            <el-form ref="modelForm" :model="modelForm" label-width="110px" size="small" class="search-form" :rules="ruleModelForm">
                <el-divider content-position="left">基础配置</el-divider>
                <el-form-item label="模板类型" prop="templateType">
                    <el-select v-model="modelForm.templateType" clearable placeholder="请选择" style="width: 400px">
                        <el-option v-for="(item,index) in templateTypeList" :key="index" :label="item.desc" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="模板名称" prop="title">
                    <el-input type="text" v-model="modelForm.title" clearable disabled placeholder="请输入模板名称" style="width: 400px"></el-input>
                </el-form-item>

                <!-- <el-form-item label="类型" prop="realTime">
                    <el-radio-group v-model="modelForm.realTime">
                         <el-radio :label="1">实时</el-radio>
                         <el-radio :label="2">定时</el-radio>
                    </el-radio-group>
               </el-form-item> -->

                <el-form-item label="模板ID" prop="templateId">
                    <el-input type="text" v-model="modelForm.templateId" clearable disabled placeholder="请输入模板ID" style="width: 400px"></el-input>
                </el-form-item>

                <el-form-item label="公众号APPID" prop="appId">
                    <el-input type="text" v-model="modelForm.appId" clearable disabled placeholder="请输入公众号APPID" style="width: 400px"></el-input>
                </el-form-item>

                <el-form-item label="模板内容" prop="content">
                    <el-input type="textarea" v-model="modelForm.content" autosize clearable disabled style="width: 400px"></el-input>
                </el-form-item>

                <el-form-item label="模板示例" prop="example">
                    <el-input type="textarea" v-model="modelForm.example" clearable autosize disabled style="width: 400px"></el-input>
                </el-form-item>

                <el-form-item label="描述" prop="description">
                    <el-input type="textarea" v-model="modelForm.description" clearable autosize style="width: 400px"></el-input>
                </el-form-item>

                <el-divider content-position="left">跳转配置</el-divider>

                <el-form-item label="小程序APPID" prop="miniAppId">
                    <el-input type="text" v-model="modelForm.miniAppId" clearable placeholder="请输入小程序APPID" style="width: 400px"></el-input>
                </el-form-item>

                <el-form-item label="跳转小程序路径" prop="miniPagePath">
                    <el-input type="text" v-model="modelForm.miniPagePath" clearable placeholder="请输入跳转小程序路径" style="width: 400px"></el-input>
                </el-form-item>

                <el-form-item label="跳转H5路径" prop="url">
                    <el-input type="text" v-model="modelForm.url" clearable placeholder="请输入跳转H5路径" style="width: 400px"></el-input>
                </el-form-item>

                <el-form-item label="状态" prop="enable">
                    <el-radio-group v-model="modelForm.enable">
                         <el-radio label="1">开启</el-radio>
                         <el-radio label="0">关闭</el-radio>
                    </el-radio-group>
               </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShow = false" size="small">取 消</el-button>
                <el-button type="primary" @click="handleConfirm" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    export default {
        data() {
            return{
                permTypes: [],
                accessToken: {},
                searchForm:{
                    title:'',
                    appId:'',
                    templateId:'',
                    templateType:'',
                    current:1,
                    size:10,
                },
                loading:false,
                tableData:[],
                isLoading:false,
                total:0,
                isShow:false,
                title:'',
                modelForm:{
                    title:'',
                    templateId:'',
                    appId:'',
                    content:'{{first.DATA}} 服务事项：{{keyword1.DATA}}服务内容：{{keyword2.DATA}}申请人：{{keyword3.DATA}}申请时间：{{keyword4.DATA}}{{description.DATA}}',
                    example:'A酒店有新的待处理事项服务事项：酒店服务服务内容：续住申请人：1005房间申请时间：2022-10-25 23:59:23请尽快登录后台处理',
                    miniAppId:'',
                    miniPagePath:'',
                    url:'',
                    enable: "0",
                    realTime: 1,
                    description: ""
                },
                ruleModelForm:{
                    title:[{ required: true, message:"请输入模板名称", trigger: 'blur'}],
                    templateId:[{ required: true, message:"请输入模板id", trigger: 'blur'}],
                    appId:[{ required: true, message:"请输入公众号appid", trigger: 'blur'}],
                    content:[{ required: true, message:"请输入公众号appid", trigger: 'blur'}],
                },

                wxMpTemplateId:'',
                AppIdList:[],
                templateTypeList:[],
            }
        },
        methods:{
            getTemplateTypeList() {
                this.getRequest(`/df-wx/templateMsg/getByType?type=1`)
                .then(res => {
                    let data = res.data;
                    if(data.code == 200){
                        this.templateTypeList = data.data;
                    }
                })
            },

            getTableData(){
                this.isLoading = true;
                this.getRequest(`/df-wx/templateMsg/getPage`,this.searchForm).then(res => {
                    if(res.data.code == 200){
                        this.tableData = res.data.data.records;
                        this.total = res.data.data.total;
                    }
                })
            },
            handleSearch(){
                this.searchForm.current = 1;
                this.getTableData();
            },
            handleReset(){
                this.searchForm = {
                    title:'',
                    appId:'',
                    templateId:'',
                    templateType:'',
                    current:1,
                    size:10,
                };
                this.getTableData();
            },
            handleCurrentChange(v){
                this.searchForm.current = v;
                this.getTableData();
            },
            handleSizeChange(v){
                this.searchForm.size = v;
                this.searchForm.current = 1;
                this.getTableData();
            },
            handleAdd(){
                this.isShow = true;
                this.title = '新增';
                // this.$refs.modelForm.resetFields();
                this.modelForm = {
                    title:'',
                    templateId:'',
                    appId:'',
                    content:'{{first.DATA}} 服务事项：{{keyword1.DATA}}服务内容：{{keyword2.DATA}}申请人：{{keyword3.DATA}}申请时间：{{keyword4.DATA}}{{description.DATA}}',
                    example:'A酒店有新的待处理事项服务事项：酒店服务服务内容：续住申请人：1005房间申请时间：2022-10-25 23:59:23请尽快登录后台处理',
                    miniAppId:'',
                    miniPagePath:'',
                    url:'',
                    enable: "0",
                    realTime: 1,
                    description: ""
                };
            },
            handledEdit(row){
                this.title = '编辑';
                // this.$refs.modelForm.resetFields();
                this.getRequest(`/df-wx/templateMsg/${row.id}`).then(res=>{
                    if(res.data.code == 200){
                        this.modelForm = res.data.data;
                    }
                }).finally(() => {
                    this.isShow = true;
                })
            },
            handleConfirm(){//新增或编辑
                this.$refs.modelForm.validate(valid => {
                    if (valid) {
                        this.postRequest(`/df-wx/templateMsg/updateWxTemplate`,this.modelForm).then(res=>{
                            if(res.data.code == 200){
                                this.$message.success('编辑成功！');
                                this.isShow = false;
                                this.getTableData();
                            }
                        })
                    }
                })

            },
            handleDel(row){//删除
                this.$confirm('您确定要删除这条数据吗?', '确认删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest(`/df-wx/templateMsg/${row.id}`).then(res=>{
                        if(res.data.code == 200){
                            this.$message.success('删除成功');
                            this.getTableData();

                        }
                    })
                })
            },

        },
        mounted(){
            this.getTableData();
            this.getTemplateTypeList();
        }
    }

</script>